import {Component,Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';


/**
 * Composant d'affichage de la popin Certificat
 *
 * @author Lionel Gimenez
 * @date 19/08/2025
 */
@Component({
    host: {'data-test-id': 'certificat-dialog'},
    selector: 'certificat-dialog',
    templateUrl: './certificat-dialog.component.html',
})
export class CertificatDialogComponent {
    /** Indicateur de sauvegarde */
    isSaving: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { certificat: string },
        private dialogRef: MatDialogRef<CertificatDialogComponent>,
    ) {
    }

    /**
     * Handler de sauvegarde
     */
    onSave() {
        this.dialogRef.close(this.data.certificat);
    }
}